module.exports = __webpack_public_path__ + "img/randomimage (4).cc5c38d3.png";